import { ERROR_GET_ROLES, IRoleState, START_GET_ROLES, SUCCESS_GET_ROLES } from '../types'

const initialState: IRoleState = {
  roles: [],
  rolehierarchy: [],
  msg: null,
  error: false,
  loading: false
}

export default function (state = initialState, action: any) {
  switch (action.type) {
    case START_GET_ROLES:
      return {
        ...state,
        msg: null,
        error: false,
        loading: true
      }
    case SUCCESS_GET_ROLES:
      return {
        ...state,
        roles: action.payload.roles,
        rolehierarchy: action.payload.rolehierarchy,
        msg: null,
        error: false,
        loading: false
      }
    case ERROR_GET_ROLES:
      return {
        ...state,
        roles: [],
        msg: action.payload,
        error: true,
        loading: false
      }
    default:
      return state
  }
}
